// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"7f9d64db","385":"672ef562","513":"6133f073","551":"afa8acfa","706":"711ede07","726":"baf948f3"}[chunkId] + ".chunk.js";
};